import React from "react";
import DashboardLayout from "../../Pages/DashboardLayout";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Quote from "../../Pages/Quote";
import Project from "../../Pages/Project/index";
import Statistics from "../../Pages/Statistics";
import Order from "../../Pages/Orders";
import Structure from "../../Pages/Structure";
import ProjectLayout from "../../Pages/PageLayout";
import Login from "../../Pages/Login/index";
import NotFound from "../../Pages/NotFound/NotFound";
import CreateProjet from "../../Pages/CreateProjet";
import BeLayout from "../../Pages/BureauEtude";
import SelectStep from "../../Pages/BureauEtude/SelectStep";
import ManageBeStep from "../../Pages/ManageBeStep/ManageBeStep";
import StatisticsBE from "../../Pages/BEStatistics";
import SelectBeProjetc from "../../Pages/Liste-BE/SelectBeProject";
import BeProjectDetails from "../../Pages/BeProjectDetails/BeProjectdetails";
// import BeProjectGrid from "../../Pages/BeProjects";
import BeProjectGrid from "../../Pages/BeProjects/Components/BeProjectGrid";
import BeSelectProjet from "../../Pages/BeCreateProject/BeSelectProject";
import BeCreateProject from "../../Pages/BeCreateProject";
import PrivateRoute from "./Components/PrivateRoute";
// import StepsConfig from "../../Pages/ManageBeStep/Components/StepsConfig";
import BeProjectsWrapper from "../../Pages/BeProjects";
import StepsConfigWrapper from "../../Pages/ManageBeStep/Components/StepsConfig";
import StepsConfig from "../../Pages/ManageBeStep/Components/StepsConfig/Components/StepsConfig";
import SectionsStepsConfigWrapper from "../../Pages/ManageBeStep/Components/SectionsStepConfig";
import SectionsStepsConfig from "../../Pages/ManageBeStep/Components/SectionsStepConfig/Components/SectionsStepsConfig";
import VersementsPage from "../SlideMenu/Test";
import SettingsPage from "../../Pages/AdminSettings/AdminSettings";
import BeProjectDetailsTabs from "../../Pages/BeProjectDetails/BeProjectDetailsTabs";
import DemandeDetails from "../../Pages/DemandeDetails";
import QuoteDetails from "../../Pages/QuoteDetails";
/*import Register from "../../Pages/Register";
import EmailVerification from "../../Pages/Register/EmailVerification";
import ConfirmRecover from "../../Pages/RecoverPassword/Confirm";
import RecoverPassword from "../../Pages/RecoverPassword/RecoverPassword";*/

const Routers = () => {
  return (
    <div>
      <Router>
        <Routes>
           <Route path="login" element={<Login />} /> 
          <Route element={<DashboardLayout />}>
            {/* <Route index path="" element={<Statistics />} />  */}
            <Route
              index
              path=""
              element={
                <PrivateRoute>
                  <Statistics />
                </PrivateRoute>
              }
            />
            <Route path="quote" element={<Quote />} />
            <Route path="quote/:id" element={<QuoteDetails />} />
            <Route path="project" element={<Project />} />
            <Route path="stats" element={<StatisticsBE />} />
            <Route path="be-projects" element={<SelectBeProjetc />} />
            <Route path="demande-details/:id" element={<DemandeDetails />} />
            <Route path="settings" element={<SettingsPage />} />
            {/* <Route path="be-projects/:nom" element={<BeProjectDetails />} /> */}
            <Route path="be-projects/:nom" element={<BeProjectDetailsTabs />} />
            
            <Route path="projectbe" element={<BeProjectsWrapper />} >
              <Route index element={<BeProjectGrid />} />
              {/* <Route path=":beProjetId" element={<StepsConfigWrapper />} >
                <Route index element={<StepsConfig />} />
                <Route path=":stepId" element={<SectionsStepsConfigWrapper />} >
                  <Route index element={<SectionsStepsConfig />} />
                </Route>
              </Route> */}
              <Route path=":beProjetId" element={<BeLayout />} >
                <Route index element={<SelectStep />} />
                {/* <Route path=":stepId" element={<SectionsStepsConfigWrapper />} >
                  <Route index element={<SectionsStepsConfig />} />
                </Route> */}
              </Route>
            </Route>
            <Route path="select-project" element={<BeSelectProjet />} />
            {/* Route pour la modification d'un projet (avec un ID) */}
            <Route path="/select-project/:id" element={<BeSelectProjet />} />
            <Route path="create-project" element={<BeCreateProject />} />
            <Route path="bureau-etude" element={<BeLayout />}>
              <Route index path="" element={<SelectStep />} />
              <Route path=":nom" element={<ManageBeStep />} />
              {/* <Route path=":beProjetId" element={<StepsConfig />} /> */}
              {/* <Route path=":beProjetId/:nom" element={<ManageBeStep />} /> */}
              {/* <Route path="stats" element={<StatisticsBE />} /> */}
              {/* <Route path="projectbe" element={<BeProjectGrid />} /> */}
            </Route>
          </Route>
          <Route path="order" element={<Order />} />
          {/* Create Project */}
          <Route path="projet" element={<ProjectLayout />}>
            <Route index element={<CreateProjet />} />
            <Route path=":projetId" element={<Structure />} />
          </Route>
          {/* <Route path="bureau-etude" element={<BeLayout />}>
            <Route index path="" element={<SelectStep />} />
            <Route path=":nom" element={<ManageBeStep />} />
          </Route> */}
          <Route path="*" element={<NotFound />} />
          {/* <Route path="test" element={<VersementsPage />} /> */}
        </Routes>
      </Router>
    </div>
  );
};

export default Routers;